import React from "react";
import background from "@web-src/modules/auth/pages/SignUpFlowLayout/assets/background.png";

export const CXFlowLayout: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <div className="relative flex h-screen w-screen items-center justify-center overflow-hidden">
    <img
      src={background}
      alt=""
      className="absolute inset-0 z-0 h-full w-full object-cover"
    />
    <div
      className="relative z-10 flex h-full max-h-[min(783px,95vh)] w-full max-w-[min(1310px,95%)] min-w-0 items-center overflow-hidden rounded-2xl bg-white"
      style={{ boxShadow: "0px 24px 56px 0px rgba(0, 0, 0, 0.24)" }}
    >
      {children}
    </div>
  </div>
);
